import { overlays } from '@ecosystem/newron-design-system';
import React, { useState, useEffect } from 'react';

import { InfoModalContext, InfoModalContextType } from './Context';
import * as styles from './InfoModal.module.scss';

/* eslint-disable-next-line */
export interface InfoModalProps {}

const InfoModal: React.FC<InfoModalProps> = () => {
  const context = React.useContext(InfoModalContext);
  const [isOpen, setIsOpen] = useState(false);
  if (!context) {
    throw Error('InfoModal must be used within an InfoModalProvider');
  }

  const { current, clearInfoModal } = context as InfoModalContextType;

  const renderContent = (content: React.ReactElement | string | undefined) => {
    if (typeof content === 'string') {
      return (
        <section>
          <p>{content}</p>
        </section>
      );
    }

    return content;
  };
  const { Modal } = overlays;
  useEffect(() => {
    if (current) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [current]);

  return (
    <Modal isOpen={isOpen} data-test-id="info-modal" onClose={clearInfoModal} size="lg">
      <Modal.Header>{current?.title}</Modal.Header>
      <Modal.Body>
        <div className={styles.InfoModal__Content}>{renderContent(current?.content)}</div>
      </Modal.Body>
    </Modal>
  );
};

export default InfoModal;
